
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.412 1.178l-.259.005c-3.137.108-4.522 2.193-4.522 4.95L8.63 7.604H6.38a.5.5 0 00-.5.5v3.667l.009.09a.5.5 0 00.492.41l2.249-.001v10.043a.5.5 0 00.5.5h4.584l.09-.009a.5.5 0 00.41-.491V12.27h3.03a.5.5 0 00.497-.448l.376-3.667.001-.087a.5.5 0 00-.499-.464h-3.405v-1.25c-.014-.168.024-.285.104-.373a.417.417 0 01.31-.136h2.753a.5.5 0 00.5-.5V1.678a.5.5 0 00-.5-.5h-3.97zm3.468 1v2.666l-2.25.001a1.415 1.415 0 00-1.413 1.558l-.003 1.701.008.09a.5.5 0 00.492.41h3.35l-.273 2.666h-3.077l-.09.009a.5.5 0 00-.41.492v10.041H9.63V11.771l-.007-.09a.5.5 0 00-.492-.41L6.88 11.27V8.604h2.25a.5.5 0 00.5-.5v-1.97c0-2.343 1.11-3.956 3.782-3.956h3.468z","fill":"#9A7C5D","fill-rule":"evenodd"}})])
          )
        }
      }
    